module.exports = __webpack_public_path__ + "static/media/dct.7de0f438.png";